require("source-map-support").install(), function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define("NumberInput", [], n) : "object" == typeof exports ? exports.NumberInput = n() : e.NumberInput = n();
}(this, function () {
  return function (e) {
    var n = {};

    function r(t) {
      if (n[t]) return n[t].exports;
      var o = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = n, r.d = function (e, n, t) {
      r.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: t
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, n) {
      if (1 & n && (e = r(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var t = Object.create(null);
      if (r.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var o in e) {
        r.d(t, o, function (n) {
          return e[n];
        }.bind(null, o));
      }
      return t;
    }, r.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(n, "a", n), n;
    }, r.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, r.p = "/", r(r.s = 388);
  }({
    0: function _(e, n) {
      e.exports = require("react");
    },
    1: function _(e, n) {
      e.exports = require("prop-types");
    },
    10: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(1),
          a = r.n(i),
          u = r(2);

      function c() {
        var e = o()(["\n  align-content: ", ";\n  align-items: ", ";\n  align-self: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  order: ", ";\n  overflow: ", ";\n"]);
        return c = function c() {
          return e;
        }, e;
      }

      var s = r.n(u).a.div(c(), function (e) {
        return e.alignContent;
      }, function (e) {
        return e.alignItems;
      }, function (e) {
        return e.alignSelf;
      }, function (e) {
        return e.inline ? "inline-flex" : "flex";
      }, function (e) {
        return e.flexBasis;
      }, function (e) {
        return e.flexDirection;
      }, function (e) {
        return e.flexGrow;
      }, function (e) {
        return e.flexShrink;
      }, function (e) {
        return e.flexWrap ? "wrap" : "nowrap";
      }, function (e) {
        return e.justifyContent;
      }, function (e) {
        return e.order;
      }, function (e) {
        return e.overflow;
      });
      s.propTypes = {
        alignContent: a.a.string,
        alignItems: a.a.string,
        alignSelf: a.a.string,
        flexBasis: a.a.oneOfType([a.a.number, a.a.string]),
        flexDirection: a.a.string,
        flexGrow: a.a.number,
        flexShrink: a.a.number,
        flexWrap: a.a.bool,
        inline: a.a.bool,
        justifyContent: a.a.string,
        overflow: a.a.string,
        order: a.a.number
      }, s.defaultProps = {
        alignContent: "stretch",
        alignItems: "stretch",
        alignSelf: "auto",
        flexBasis: "auto",
        flexDirection: "row",
        flexGrow: 0,
        flexShrink: 1,
        flexWrap: !1,
        inline: !1,
        justifyContent: "flex-start",
        order: 0,
        overflow: "hidden"
      }, s.displayName = "FlexContainer", n.a = s;
    },
    11: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
    },
    16: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/getPrototypeOf");
    },
    18: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/assertThisInitialized");
    },
    19: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(1),
          a = r.n(i),
          u = r(2);

      function c() {
        var e = o()(["\n  order: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n  align-self: ", ";\n"]);
        return c = function c() {
          return e;
        }, e;
      }

      var s = r.n(u).a.div(c(), function (e) {
        return e.order;
      }, function (e) {
        return e.flexGrow;
      }, function (e) {
        return e.flexShrink;
      }, function (e) {
        return e.flexBasis;
      }, function (e) {
        return e.alignSelf;
      });
      s.propTypes = {
        order: a.a.number,
        flexGrow: a.a.number,
        flexShrink: a.a.number,
        flexBasis: a.a.oneOfType([a.a.number, a.a.string]),
        alignSelf: a.a.string
      }, s.defaultProps = {
        order: 0,
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: "auto",
        alignSelf: "auto"
      }, n.a = s;
    },
    194: function _(e, n, r) {
      "use strict";

      r.r(n);
      var t = r(84);
      n.default = t.a;
    },
    2: function _(e, n) {
      e.exports = require("styled-components");
    },
    20: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(0),
          a = r.n(i),
          u = r(1),
          c = r.n(u),
          s = r(2),
          f = r.n(s),
          l = r(7);

      function d() {
        var e = o()(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      var p = f()(function (e) {
        var n = e.children,
            r = e.className;
        return a.a.Children.only(a.a.cloneElement(n, {
          className: r
        }));
      })(d(), function (e) {
        var n = e.padding;
        return Object(l.a)({
          attribute: "padding",
          value: n
        });
      }, function (e) {
        var n = e.paddingTop;
        return Object(l.a)({
          attribute: "padding-top",
          value: n
        });
      }, function (e) {
        var n = e.paddingBottom;
        return Object(l.a)({
          attribute: "padding-bottom",
          value: n
        });
      }, function (e) {
        var n = e.paddingLeft;
        return Object(l.a)({
          attribute: "padding-left",
          value: n
        });
      }, function (e) {
        var n = e.paddingRight;
        return Object(l.a)({
          attribute: "padding-right",
          value: n
        });
      });
      n.a = p, p.propTypes = {
        padding: c.a.oneOfType([c.a.string, c.a.number]),
        paddingTop: c.a.oneOfType([c.a.string, c.a.number]),
        paddingBottom: c.a.oneOfType([c.a.string, c.a.number]),
        paddingLeft: c.a.oneOfType([c.a.string, c.a.number]),
        paddingRight: c.a.oneOfType([c.a.string, c.a.number])
      };
    },
    23: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/classCallCheck");
    },
    24: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/createClass");
    },
    25: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/inherits");
    },
    26: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/possibleConstructorReturn");
    },
    3: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    32: function _(e, n, r) {
      "use strict";

      r.d(n, "c", function () {
        return J;
      }), r.d(n, "b", function () {
        return K;
      });
      var t = r(11),
          o = r.n(t),
          i = r(23),
          a = r.n(i),
          u = r(24),
          c = r.n(u),
          s = r(18),
          f = r.n(s),
          l = r(25),
          d = r.n(l),
          p = r(26),
          b = r.n(p),
          g = r(16),
          h = r.n(g),
          y = r(6),
          m = r.n(y),
          v = r(0),
          x = r.n(v),
          O = r(1),
          w = r.n(O),
          j = r(45),
          P = r(20),
          S = r(19),
          k = r(3),
          F = r.n(k),
          B = r(2),
          E = r.n(B),
          C = r(5),
          z = r(10),
          T = E.a.input({});
      T.propTypes = {
        type: w.a.oneOf(["email", "number", "password", "search", "tel", "text", "date"])
      }, T.defaultProps = {
        type: "text"
      }, T.displayName = "InputAtom";
      var R = T;

      function I() {
        var e = F()(["\n  appearance: none;\n\n  width: 100%;\n  padding: 0;\n  border: none;\n\n  box-sizing: border-box;\n\n  transition-timing-function: ease-in-out;\n  transition-duration: 0.15s;\n  transition-property: background-color, color;\n\n  ", ";\n  ", ";\n  ", ";\n\n  background-color: transparent;\n  &[type=number] {\n   appearance: textfield;\n  }\n\n  &::-webkit-inner-spin-button, ::-webkit-outer-spin-button {\n    appearance: none;\n\n    margin: 0;\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &::-ms-input-placeholder /* Microsoft Edge */, &:-ms-input-placeholder /* Internet Explorer 10-11 */ {\n    ", ";\n    transition: color .15s ease-in-out;\n    user-select: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\n    ", ";\n    opacity: 1; /* Firefox */\n    user-select: none;\n\n    transition: color .15s ease-in-out;\n  }\n\n  &:focus::placeholder {\n    ", ";\n  }\n\n  &:disabled {\n    cursor: inherit;\n  }\n"]);
        return I = function I() {
          return e;
        }, e;
      }

      function W() {
        var e = F()(["\n  min-width: fit-content;\n"]);
        return W = function W() {
          return e;
        }, e;
      }

      function H() {
        var e = F()(["\n  color: ", ";\n"]);
        return H = function H() {
          return e;
        }, e;
      }

      function D() {
        var e = F()(["\n    color: ", ";\n  "]);
        return D = function D() {
          return e;
        }, e;
      }

      function G() {
        var e = F()(["\n    padding-top: ", "px;\n    padding-right: ", "px;\n    padding-bottom: ", "px;\n    padding-left: ", "\n  "]);
        return G = function G() {
          return e;
        }, e;
      }

      function N() {
        var e = F()(["\n    height: ", "px;\n  "]);
        return N = function N() {
          return e;
        }, e;
      }

      function q() {
        var e = F()(["\n    color: ", ";\n    font-family: ", ";\n    font-size: ", "px;\n    line-height: ", "px;\n  "]);
        return q = function q() {
          return e;
        }, e;
      }

      var U = function U(e) {
        var n,
            r = e.hasTitle,
            t = e.disabled,
            o = e.theme.colors;
        return n = t || r ? o.grey40 : o.grey, Object(B.css)(D(), n);
      },
          M = E()(z.a).attrs({
        alignItems: "center",
        justifyContent: "center"
      })(W());

      M.displayName = "SideItem";

      var _ = E()(R)(I(), function (e) {
        var n = e.size,
            r = e.theme.fonts,
            t = e.leftPadding,
            o = Object(C.i)(n, r).padding,
            i = o.vertical,
            a = o.horizontal,
            u = t || "".concat(a, "px");
        return Object(B.css)(G(), i - 1, a, i - 1, u);
      }, function (e) {
        var n = e.theme,
            r = n.fonts,
            t = n.colors,
            o = e.size,
            i = e.disabled,
            a = Object(C.i)(o, r).font,
            u = i ? t.grey40 : t.brand160;
        return Object(B.css)(q(), u, a.fontFamily, a.fontSize, a.lineHeight);
      }, function (e) {
        var n = e.size,
            r = e.theme.fonts,
            t = Object(C.i)(n, r).height;
        return Object(B.css)(N(), t - 2);
      }, U, U, function (e) {
        var n = e.theme.colors;
        return Object(B.css)(H(), n.grey40);
      });

      function A(e, n) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var t = Object.getOwnPropertySymbols(e);
          n && (t = t.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })), r.push.apply(r, t);
        }

        return r;
      }

      function L() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }

      _.displayName = "InternalInput";

      var J = {
        inputRef: w.a.shape({
          current: w.a.instanceOf(w.a.node)
        }),
        size: w.a.oneOf(["xs", "sm", "md", "lg"]),
        type: w.a.oneOf(["email", "number", "password", "search", "tel", "text", "date"]),
        fullWidth: w.a.bool,
        containsError: w.a.bool,
        disabled: w.a.bool,
        hasTitle: w.a.bool,
        placeholder: w.a.string,
        value: w.a.string,
        rightItem: w.a.node,
        leftItem: w.a.node,
        onChange: w.a.func,
        onFocus: w.a.func,
        onBlur: w.a.func,
        leftPadding: w.a.string
      },
          K = {
        inputRef: null,
        size: "md",
        type: "text",
        fullWidth: !1,
        containsError: !1,
        disabled: !1,
        hasTitle: !1,
        placeholder: "",
        value: void 0,
        rightItem: null,
        leftItem: null,
        onChange: function onChange() {},
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        leftPadding: null
      },
          Q = function (e) {
        d()(t, e);
        var n,
            r = (n = t, function () {
          var e,
              r = h()(n);

          if (L()) {
            var t = h()(this).constructor;
            e = Reflect.construct(r, arguments, t);
          } else e = r.apply(this, arguments);

          return b()(this, e);
        });

        function t() {
          var e;
          return a()(this, t), e = r.call(this), m()(f()(e), "onFocus", function (n) {
            (0, e.props.onFocus)(n), e.setState(function () {
              return {
                focus: !0
              };
            });
          }), m()(f()(e), "onBlur", function (n) {
            (0, e.props.onBlur)(n), e.setState(function () {
              return {
                focus: !1
              };
            });
          }), m()(f()(e), "onSideClick", function () {
            var n = e.props.inputRef;
            n && n.current.focus();
          }), e.state = {
            focus: !1
          }, e;
        }

        return c()(t, [{
          key: "render",
          value: function value() {
            var e = this.state.focus,
                n = this.props,
                r = n.size,
                t = n.containsError,
                i = n.onChange,
                a = n.placeholder,
                u = n.leftItem,
                c = n.rightItem,
                s = n.type,
                f = n.inputRef,
                l = n.fullWidth,
                d = n.disabled,
                p = n.hasTitle,
                b = n.leftPadding,
                g = o()(n, ["size", "containsError", "onChange", "placeholder", "leftItem", "rightItem", "type", "inputRef", "fullWidth", "disabled", "hasTitle", "leftPadding"]);
            return x.a.createElement(j.a, {
              focus: e,
              containsError: t,
              disabled: d,
              fullWidth: l,
              size: r
            }, u && x.a.createElement(P.a, {
              paddingLeft: 10
            }, x.a.createElement(M, {
              onClick: this.onSideClick
            }, x.a.cloneElement(u, {
              disabled: d
            }))), x.a.createElement(S.a, {
              style: {
                flexGrow: 1
              }
            }, x.a.createElement(_, function (e) {
              for (var n = 1; n < arguments.length; n++) {
                var r = null != arguments[n] ? arguments[n] : {};
                n % 2 ? A(Object(r), !0).forEach(function (n) {
                  m()(e, n, r[n]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : A(Object(r)).forEach(function (n) {
                  Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
                });
              }

              return e;
            }({}, g, {
              type: s,
              placeholder: a,
              size: r,
              onChange: i,
              innerRef: f,
              disabled: d,
              hasTitle: p,
              hasFocus: e,
              onBlur: this.onBlur,
              onFocus: this.onFocus,
              leftPadding: b
            }))), c && x.a.createElement(P.a, {
              paddingRight: 10
            }, x.a.createElement(M, {
              onClick: this.onSideClick
            }, x.a.cloneElement(c, {
              disabled: d
            }))));
          }
        }]), t;
      }(v.Component);

      Q.defaultProps = K;
      n.a = Q;
    },
    388: function _(e, n, r) {
      e.exports = r(194);
    },
    4: function _(e) {
      e.exports = JSON.parse('{"white":"#ffffff","brand":"#0d51ff","brand10":"#e6edff","brand20":"#c5d2f5","brand40":"#96b1f7","brand60":"#6992fa","brand80":"#3a71fc","brand120":"#0a40cc","brand140":"#073099","brand160":"#052066","brand180":"#021033","grey":"#475b68","grey10":"#f8f8f8","grey20":"#f0f0f0","grey40":"#bbc3ca","grey60":"#919da4","grey80":"#6c7c86","grey120":"#384853","grey140":"#2a363e","grey160":"#1c2429","grey180":"#0e1214","success":"#00ab5b","successhover":"#008848","successlight":"#66cd9d","successbackground":"#e5f6ee","warninghover":"#cc9c00","warning":"#ffc400","warninglight":"#ffdc66","warningabsence":"#ffedb2","warningbackground":"#fff9e6","alerthover":"#cc180b","alert":"#ff1e0e","alertlight":"#ff786e","alertbackground":"#ffe8e6","infohover":"#b01863","info":"#dc1e7c","infolight":"#ea78b0","infobackground":"#fbe8f2","supporthover":"#583ac3","support":"#6e49f4","supportlight":"#a892f8","supportbackground":"#f0ecfe","boxshadowmedium":"rgba(71, 91, 104, 0.1)","modaloverlay":"rgba(2, 16, 51, 0.5)","transparent":"transparent"}');
    },
    45: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(6),
          a = r.n(i),
          u = r(11),
          c = r.n(u),
          s = r(2),
          f = r.n(s),
          l = r(1),
          d = r.n(l),
          p = r(10),
          b = r(5);

      function g() {
        var e = o()(["\n  appearance: none;\n\n  box-sizing: border-box;\n\n  cursor: ", ";\n  width: ", ";\n  ", ";\n  ", ";\n\n  border-radius: 3px;\n  border: 1px solid ", ";\n\n  transition-duration: 0.15s;\n  transition-timing-function: ease-in-out;\n  transition-property: border, background;\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"]);
        return g = function g() {
          return e;
        }, e;
      }

      function h() {
        var e = o()(["\n    background-color: ", ";\n  "]);
        return h = function h() {
          return e;
        }, e;
      }

      function y() {
        var e = o()(["background-color: ", ";"]);
        return y = function y() {
          return e;
        }, e;
      }

      function m() {
        var e = o()(["\n    height: ", "px;\n  "]);
        return m = function m() {
          return e;
        }, e;
      }

      function v(e, n) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var t = Object.getOwnPropertySymbols(e);
          n && (t = t.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })), r.push.apply(r, t);
        }

        return r;
      }

      var x = function x(e) {
        var n = e.disabled,
            r = e.containsError,
            t = e.focus,
            o = e.theme.colors;
        return n ? o.grey20 : r ? o.alert : t ? o.brand : o.grey40;
      },
          O = f()(p.a)(g(), function (e) {
        return e.disabled ? "not-allowed" : "text";
      }, function (e) {
        return e.fullWidth ? "100%" : "fit-content";
      }, function (e) {
        var n = e.size,
            r = e.theme.fonts,
            t = Object(b.i)(n, r).height;
        return Object(s.css)(m(), t);
      }, function (e) {
        var n = e.disabled,
            r = e.theme.colors;
        return n ? Object(s.css)(y(), r.grey20) : Object(s.css)(h(), r.white);
      }, x, function (e) {
        var n = e.focus,
            r = e.disabled,
            t = e.theme.colors,
            o = c()(e, ["focus", "disabled", "theme"]);
        return n || r ? x(function (e) {
          for (var n = 1; n < arguments.length; n++) {
            var r = null != arguments[n] ? arguments[n] : {};
            n % 2 ? v(Object(r), !0).forEach(function (n) {
              a()(e, n, r[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : v(Object(r)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
            });
          }

          return e;
        }({
          focus: n,
          disabled: r,
          theme: {
            colors: t
          }
        }, o)) : t.grey;
      });

      O.propTypes = {
        containsError: d.a.bool,
        focus: d.a.bool,
        fullWidth: d.a.bool
      }, O.defaultProps = {
        containsError: !1,
        focus: !1,
        fullWidth: !1
      }, O.displayName = "InputBorder", n.a = O;
    },
    5: function _(e, n, r) {
      "use strict";

      r.d(n, "a", function () {
        return h;
      }), r.d(n, "e", function () {
        return i;
      }), r.d(n, "j", function () {
        return a;
      }), r.d(n, "f", function () {
        return u;
      }), r.d(n, "g", function () {
        return c;
      }), r.d(n, "i", function () {
        return l;
      }), r.d(n, "c", function () {
        return d;
      }), r.d(n, "k", function () {
        return d;
      }), r.d(n, "l", function () {
        return p;
      }), r.d(n, "b", function () {
        return b;
      }), r.d(n, "d", function () {
        return g;
      }), r.d(n, "h", function () {
        return f;
      });

      var t = r(4),
          o = r(9),
          i = function i(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand;

          case "secondary":
          case "normal":
          default:
            return n.grey;

          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          case "brand160":
            return n.brand160;

          case "white":
            return n.white;
        }
      },
          a = function a(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand60;

          case "secondary":
          case "normal":
          default:
            return n.grey40;

          case "info":
            return n.infolight;

          case "support":
            return n.supportlight;

          case "success":
            return n.successlight;

          case "warning":
            return n.warninglight;

          case "alert":
            return n.alertlight;

          case "grey20":
          case "white":
            return n.grey20;
        }
      },
          u = function u(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand120;

          case "secondary":
          case "normal":
          default:
            return n.grey140;

          case "info":
            return n.infohover;

          case "support":
            return n.supporthover;

          case "success":
            return n.successhover;

          case "warning":
            return n.warninghover;

          case "alert":
            return n.alerthover;

          case "white":
            return n.grey20;
        }
      },
          c = function c(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o;

        switch (e) {
          case "xxs":
            return n.Body4;

          case "xs":
            return n.Body3;

          case "sm":
            return n.Body2;

          case "md":
          default:
            return n.Body1;

          case "lg":
            return n.H5;

          case "xl":
            return n.H4;

          case "xxl":
            return n.H3;

          case "xxxl":
            return n.H2;

          case "xxxxl":
            return n.H1;
        }
      },
          s = Object.freeze({
        xs: 24,
        sm: 30,
        md: 40,
        lg: 50
      }),
          f = function f(e) {
        return s[e] || s.md;
      },
          l = function l(e, n) {
        var r = {
          padding: {
            vertical: 0,
            horizontal: 10
          },
          font: {},
          supportFont: {},
          height: 0
        };

        switch (e) {
          case "xs":
            r.padding.vertical = 6, r.font = n.Body3, r.supportFont = n.Body4;
            break;

          case "sm":
            r.padding.vertical = 8, r.font = n.Body1, r.supportFont = n.Body3;
            break;

          default:
          case "md":
            r.padding.vertical = 12, r.font = n.Body1, r.supportFont = n.Body3;
            break;

          case "lg":
            r.padding.vertical = 17, r.font = n.Body1, r.supportFont = n.Body3;
        }

        return r.height = f(e), r;
      },
          d = function d(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "primary":
            return n.brand10;

          case "info":
            return n.infobackground;

          case "support":
            return n.supportbackground;

          case "success":
            return n.successbackground;

          case "warning":
            return n.warningbackground;

          case "alert":
            return n.alertbackground;

          case "normal":
          default:
            return n.white;
        }
      },
          p = function p(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "warning":
            return n.brand160;

          case "info":
          case "support":
          case "success":
          case "alert":
          default:
            return n.white;
        }
      },
          b = function b(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          default:
            return n.brand;
        }
      },
          g = function g(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (e) {
          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          default:
            return n.brand;
        }
      },
          h = new Map([[0, "rgb(110,73,244)"], [1, "#098256"], [2, "#7300B3"], [3, "#052066"], [4, "#6E49F4"], [5, "#0A40CC"], [6, "#FFB300"], [7, "#FF1E0E"], [8, "#038F00"], [9, "#CC34AF"], [10, "#11AEEF"], [11, "#475B68"], [12, "#DC1E7C"], [13, "#30C881"], [14, "#FF6A12"], [15, "#2D9898"]]);
    },
    6: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/defineProperty");
    },
    7: function _(e, n, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(2);

      function a() {
        var e = o()(["", ": ", ""]);
        return a = function a() {
          return e;
        }, e;
      }

      function u() {
        var e = o()(["", ": ", "px"]);
        return u = function u() {
          return e;
        }, e;
      }

      n.a = function (e) {
        var n = e.attribute,
            r = e.value;

        if (void 0 !== r) {
          if ("number" == typeof r) return Object(i.css)(u(), n, r);
          if ("string" == typeof r) return Object(i.css)(a(), n, r);
          throw new Error("".concat(r, " is not of valid type for ").concat(n, ".\n      prop can either number or string"));
        }
      };
    },
    84: function _(e, n, r) {
      "use strict";

      var t = r(6),
          o = r.n(t),
          i = r(2),
          a = r.n(i),
          u = r(32);

      function c(e, n) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var t = Object.getOwnPropertySymbols(e);
          n && (t = t.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })), r.push.apply(r, t);
        }

        return r;
      }

      function s(e) {
        for (var n = 1; n < arguments.length; n++) {
          var r = null != arguments[n] ? arguments[n] : {};
          n % 2 ? c(Object(r), !0).forEach(function (n) {
            o()(e, n, r[n]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (n) {
            Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
          });
        }

        return e;
      }

      var f = a()(u.a).attrs({
        type: "number"
      })({});
      f.propTypes = s({}, u.c), f.defaultProps = s({}, u.b, {
        type: "number"
      }), f.displayName = "NumberInput", n.a = f;
    },
    9: function _(e) {
      e.exports = JSON.parse('{"H1":{"fontFamily":"URWGeometric","fontSize":46,"lineHeight":64},"H2":{"fontFamily":"URWGeometric","fontSize":38,"lineHeight":54},"H3":{"fontFamily":"URWGeometric","fontSize":26,"lineHeight":36},"H4":{"fontFamily":"URWGeometric","fontSize":20,"lineHeight":28},"H5":{"fontFamily":"URWGeometric","fontSize":18,"lineHeight":26},"Body1":{"fontFamily":"URWGeometric","fontSize":16,"lineHeight":22},"Body2":{"fontFamily":"URWGeometric","fontSize":14,"lineHeight":20},"Body3":{"fontFamily":"URWGeometric","fontSize":12,"lineHeight":16},"Body4":{"fontFamily":"URWGeometric","fontSize":10,"lineHeight":14}}');
    }
  });
});